import React, { useEffect, useRef, useState } from 'react';
import Barras from './Barras';
import {
  AREAS_DO_PAINEL,
  AREAS_EM_ORDEM,
  EXECUCAO,
  PESOS,
  ROTULO_DA_AREA,
  decimalEm,
  notaDe,
  perdaDe
} from './amostra';
import { LIMIARES } from '../../utils/seoMetrics';
import { Link, useIdioma } from '../../i18n';
import { useFormato } from '../../i18n/formato';
import '../../styles/CincoAreas.css';

const ITENS = { indexacao: 4, conteudo: 4, experiencia: 4, midia: 3, links: 3 };

/* Os números que os itens citam saem dos limiares que o painel usa. */
const VALORES = {
  conteudo2: { min: LIMIARES.TITULO_MIN, max: LIMIARES.TITULO_MAX },
  conteudo3: { min: LIMIARES.META_MIN, max: LIMIARES.META_MAX },
  conteudo4: { n: LIMIARES.CONTEUDO_RASO_PALAVRAS },
  experiencia1: { lenta: LIMIARES.CARGA_LENTA_MS / 1000, critica: LIMIARES.CARGA_CRITICA_MS / 1000 },
  experiencia3: { mb: LIMIARES.PAGINA_PESADA_BYTES / (1024 * 1024) }
};

const TEMPOS = ['<1 s', '1–2', '2–3', '3–5', '>5'];
const TOM_DO_TEMPO = [null, null, null, 'nh-warn', 'nh-crit'];

/** O pedaço da tela do produto que cada área mostra. */
const Recorte = ({ area, t, numero }) => {
  const e = EXECUCAO;
  if (area === 'indexacao') {
    return (
      <>
        <p className="nh-ui-titulo">{t('inicio.areas.statusDasPaginas')}</p>
        {Object.entries(e.status).map(([faixa, n]) => (
          <div className="areas-hbarra" key={faixa}>
            <span className={faixa === '2xx' ? undefined : faixa === '3xx' ? 'nh-warn' : 'nh-crit'}>{faixa}</span>
            <i
              className={faixa === '2xx' ? undefined : faixa === '3xx' ? 'is-warn' : 'is-crit'}
              style={{ width: `${Math.max(2, (n / e.total) * 100)}%` }}
            />
            <span className="nh-num">{numero(n)}</span>
          </div>
        ))}
        <div className="areas-kv areas-kv-primeiro">
          <span>{t('inicio.areas.semCanonical')}</span><span className="nh-num">{e.semCanonical}</span>
        </div>
        <div className="areas-kv">
          <span>{t('inicio.areas.naoRenderizou')}</span><span className="nh-num">{e.naoRenderizou}</span>
        </div>
      </>
    );
  }
  if (area === 'conteudo') {
    return (
      <>
        <p className="nh-ui-titulo">{t('inicio.areas.comoAparece')}</p>
        <p className="areas-serp-url"><code>{e.site} › produtos</code></p>
        <p className="areas-serp-titulo">{t('inicio.areas.serpTitulo')}</p>
        <span className="areas-selo is-warn">
          {t('inicio.areas.caracteresAcima', { n: 71, max: LIMIARES.TITULO_MAX })}
        </span>
        <p className="nh-soft">{t('inicio.areas.semMetaBuscador')}</p>
        <span className="areas-selo is-crit">{t('inicio.areas.semH1')}</span>
      </>
    );
  }
  if (area === 'experiencia') {
    const maior = Math.max(...e.tempos);
    return (
      <>
        <p className="nh-ui-titulo">{t('inicio.areas.tempoDeResposta')}</p>
        <div className="areas-histograma">
          {e.tempos.map((n, i) => (
            <i key={TEMPOS[i]} className={TOM_DO_TEMPO[i] ? `is-${TOM_DO_TEMPO[i].slice(3)}` : undefined}
              style={{ height: `${(n / maior) * 100}%` }} />
          ))}
        </div>
        <div className="areas-histograma-rotulos">
          {TEMPOS.map((faixa) => <span key={faixa}>{faixa}</span>)}
        </div>
        <div className="areas-kv areas-kv-primeiro">
          <span>{t('inicio.areas.lentasAcima', { s: LIMIARES.CARGA_LENTA_MS / 1000 })}</span>
          <span className="nh-num nh-warn">{e.lentas}</span>
        </div>
        <div className="areas-kv">
          <span>{t('inicio.areas.semViewport')}</span><span className="nh-num">{e.semViewport}</span>
        </div>
      </>
    );
  }
  if (area === 'midia') {
    const imagens = [
      ['tenis-pro-x-lateral.jpg', false],
      ['tenis-pro-x-sola.jpg', false],
      ['banner-verao.webp', false],
      ['selo-frete.svg', true]
    ];
    return (
      <>
        <p className="nh-ui-titulo">{t('inicio.areas.imagensDaPagina')}</p>
        {imagens.map(([arquivo, comAlt]) => (
          <div className="areas-item" key={arquivo}>
            <span className={`nh-ponto ${comAlt ? 'nh-ok' : 'nh-crit'}`} />
            <code>{arquivo}</code>
            <span className={comAlt ? 'nh-ok' : 'nh-crit'}>
              {t(comAlt ? 'inicio.areas.comAlt' : 'inicio.areas.semAlt')}
            </span>
          </div>
        ))}
        <div className="areas-kv areas-kv-primeiro">
          <span>{t('inicio.areas.paginasSemAlt')}</span>
          <span className="nh-num">{e.afetadas.midia}</span>
        </div>
      </>
    );
  }
  return (
    <>
      <p className="nh-ui-titulo">{t('inicio.areas.linksQuebrados')}</p>
      {['/promocao-verao', '/blog/guia-2023', '/trocas'].map((caminho) => (
        <div className="areas-item" key={caminho}>
          <code>{caminho}</code>
          <span className="nh-crit nh-num">404</span>
        </div>
      ))}
      <p className="nh-soft areas-recorte-nota">{t('inicio.areas.menuDoBlog', { n: e.linksQuebrados })}</p>
      <div className="areas-kv areas-kv-primeiro">
        <span>{t('inicio.areas.semLinkInterno')}</span><span className="nh-num">{e.semLinkInterno}</span>
      </div>
    </>
  );
};

/**
 * "Cinco áreas, uma conta": a fórmula da nota com as barras da marca, e um
 * controle por área para o visitante mexer na conta. A nota é recalculada por
 * `calcularScore`, a mesma do painel; nada aqui reimplementa a fórmula.
 *
 * O id continua `features` porque o Header e o Footer apontam para `/#features`.
 */
const CincoAreas = () => {
  const { t } = useIdioma();
  const { numero, locale } = useFormato();
  const decimal = decimalEm(locale);
  const [afetadas, setAfetadas] = useState(EXECUCAO.afetadas);
  const [foco, setFoco] = useState(null);
  const lista = useRef(null);

  useEffect(() => {
    if (!('IntersectionObserver' in window)) return undefined;
    const observador = new IntersectionObserver(
      (itens) => {
        for (const item of itens) if (item.isIntersecting) setFoco(item.target.dataset.area);
      },
      { rootMargin: '-40% 0px -40% 0px' }
    );
    lista.current.querySelectorAll('[data-area]').forEach((el) => observador.observe(el));
    return () => observador.disconnect();
  }, []);

  const perdas = Object.fromEntries(AREAS_EM_ORDEM.map((area) => [area, perdaDe(area, afetadas[area])]));
  const mudar = (area, valor) => {
    setFoco(area);
    setAfetadas((atual) => ({ ...atual, [area]: valor }));
  };

  return (
    <section className="areas" id="features" aria-labelledby="areas-titulo">
      <div className="nh-grade">
        <div className="areas-pino">
          <h2 id="areas-titulo">{t('inicio.areas.titulo')}</h2>
          <div className="areas-placar" data-foco={foco || undefined}>
            <p className="areas-nota" aria-live="polite">
              <output className="nh-num">{notaDe(afetadas)}</output>
              <span>{t('inicio.tela.deCem')}</span>
            </p>
            <div className="areas-barras" aria-hidden="true">
              <Barras
                areas={AREAS_EM_ORDEM}
                pesos={PESOS}
                perdas={perdas}
                rotulo={(area) => t(ROTULO_DA_AREA[area])}
                decimal={decimal}
                foco={foco}
              />
            </div>
            <p className="areas-formula">
              {t('inicio.areas.formulaAntes')} <b>{t('inicio.areas.formulaConta')}</b>.{' '}
              {t('inicio.areas.formulaDepois')}
            </p>
          </div>
        </div>

        <div className="areas-lista" ref={lista}>
          {AREAS_DO_PAINEL.map((area) => (
            <article className="areas-area" data-area={area} key={area} data-r>
              <h3>{t('inicio.areas.pontos', { area: t(ROTULO_DA_AREA[area]), n: PESOS[area] })}</h3>
              <div className="areas-linha">
                <figure className="areas-recorte" data-ui>
                  <Recorte area={area} t={t} numero={numero} />
                </figure>
                <ul className="nh-lista">
                  {Array.from({ length: ITENS[area] }, (_, i) => `${area}${i + 1}`).map((chave) => (
                    <li key={chave}>{t(`inicio.areas.${chave}`, VALORES[chave])}</li>
                  ))}
                </ul>
              </div>
              <label className="areas-controle">
                <span className="areas-controle-topo">
                  <span>{t(`inicio.areas.controle.${area}`)}</span>
                  <output className="nh-num">
                    {t('inicio.areas.deTotal', { n: numero(afetadas[area]), total: numero(EXECUCAO.total) })}
                  </output>
                </span>
                <input
                  type="range"
                  min="0"
                  max={EXECUCAO.total}
                  value={afetadas[area]}
                  onChange={(e) => mudar(area, Number(e.target.value))}
                />
              </label>
            </article>
          ))}
        </div>

        <div className="areas-fecho" data-r>
          <p>{t('inicio.areas.fecho')}</p>
          <Link to="/signup" className="sp-btn sp-btn-on-section nh-btn">
            {t('inicio.areas.acao')} <span className="nh-seta" aria-hidden="true">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CincoAreas;
